<template>
  <grid
    :gridConfigUrl="gridConfigUrl" >
    <template slot="headerColumns">
      <grid-table-col>发送对象</grid-table-col>
      <grid-table-col>邮件详情</grid-table-col>
    </template>
    <template slot="bodyColumns" slot-scope="props">
      <grid-common-menu><label @click="viewSendStatus">查看发送对象</label></grid-common-menu>
      <grid-common-menu>
        <a target="_blank"
           :href="oldPlatformUrl + '/entity/information/peSms_viewDetail.action?ids=' + props.row.id"
        >
          查看邮件详情
        </a>
      </grid-common-menu>
    </template>
  </grid>
</template>
<script>
  import Grid from '../../../components/grid/grid.vue'
  import GridTableCol from '../../../components/grid-menu/grid-table-col.vue'
  import GridCommonMenu from '../../../components/grid-menu/grid-common-menu.vue'

  export default {
    components: {
      GridCommonMenu,
      GridTableCol,
      Grid
    },
    name: 'basic-mail-grid',
    data() {
      return {
        gridConfigUrl: ''
      }
    },
    computed: {
      oldPlatformUrl: function () {
        return this.$store.state.app.oldPlatformUrl
      }
    },
    created() {
      this.gridConfigUrl = this.$route.meta.url
    },
    methods: {
      viewSendStatus() {
        this.$router.push({name: 'basicMailViewSendStatus'})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/custom/components/grid/basic-mail-grid.vue